export default "__VITE_ASSET__73d7a087__"